// Create types
export const DEDUCTION_CREATE_ERROR = 'DEDUCTION_CREATE_ERROR';
export const DEDUCTION_CREATE_LOADING = 'DEDUCTION_CREATE_LOADING';
export const DEDUCTION_CREATE_SUCCESS = 'DEDUCTION_CREATE_SUCCESS';
export const DEDUCTION_CREATE_VIOLATIONS = 'DEDUCTION_CREATE_VIOLATIONS';
export const DEDUCTION_CREATE_RESET = 'DEDUCTION_CREATE_RESET';

// Delete types
export const DEDUCTION_DELETE_ERROR = 'DEDUCTION_DELETE_ERROR';
export const DEDUCTION_DELETE_LOADING = 'DEDUCTION_DELETE_LOADING';
export const DEDUCTION_DELETE_SUCCESS = 'DEDUCTION_DELETE_SUCCESS';
export const DEDUCTION_DELETE_RESET = 'DEDUCTION_DELETE_RESET';

// List types
export const DEDUCTION_LIST_ERROR = 'DEDUCTION_LIST_ERROR';
export const DEDUCTION_LIST_LOADING = 'DEDUCTION_LIST_LOADING';
export const DEDUCTION_LIST_RESET = 'DEDUCTION_LIST_RESET';
export const DEDUCTION_LIST_PAGINATION = 'DEDUCTION_LIST_PAGINATION';
export const DEDUCTION_LIST_SUCCESS = 'DEDUCTION_LIST_SUCCESS';
export const DEDUCTION_LIST_ORDER = 'DEDUCTION_LIST_ORDER';
export const DEDUCTION_LIST_PAGE = 'DEDUCTION_LIST_PAGE';
export const DEDUCTION_LIST_FILTER = 'DEDUCTION_LIST_FILTER';


// WEBPACK FOOTER //
// ./src/store/modules/deduction/mutation-types.js